<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div class="ScanInput_lr" v-if="visibles">
    <div>
      <el-input
        :disabled="isdisable"
        ref="Commodity"
        size="mini"
        v-model="value1"
        @focus="doFocus"
        @blur="doBlur"
        @input="inputText"
        @keyup.down.native="downkey($event)"
        @keyup.up.prevent.native="upkey($event)"
        @keyup.enter.native="submitForm"
      ></el-input>
      <el-popover placement="top-start" width="414" trigger="manual" v-model="visible">
        <vxe-table
          border
          highlight-hover-row
          highlight-current-row
          :keyboard-config="{isArrow:true}"
          :auto-resize="true"
          resizable
          align="center"
          size="small"
          ref="xTable"
          height="250"
          :data="tableData"
          show-overflow
          show-header-overflow
          @cell-click="clickRow"
        >
          <template v-for="(item,index) in tableHeadData">
            <vxe-table-column :field="item.Key" :title="item.Label" :key="index"></vxe-table-column>
          </template>
        </vxe-table>
      </el-popover>
    </div>
    <div style="display:flex;">
      <el-input
        style="width:80px;margin-left: 10px;"
        v-if="checked"
        size="mini"
        v-model="CommodityQty"
        @keyup.enter.native="submitForm"
        @input="CommodityQty=CommodityQty.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')"
      ></el-input>
      <el-checkbox style="margin: 4px 0 0 10px" v-model="checked">录入数量</el-checkbox>
      <!-- <i class="el-icon-close" style="line-height: 26px;margin-left: 15px;" @click="visibles=false"></i> -->
    </div>
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool";

export default {
  data() {
    return {
      // visibles: false,
      checked: false,
      // 值字段
      value1: "",
      CommodityQty: "1",
      oldVal1: {},
      tableHeadData: [
        { Label: "商品名称", Key: "FullName" },
        { Label: "商品编号", Key: "BaseCode" },
        { Label: "可用库存", Key: "AQty" },
        { Label: "单位", Key: "UnitName" }
        // { Label: "规格", Key: "Standards" },
        // { Label: "型号", Key: "Model" },
        // { Label: "产地", Key: "ProArea" }
      ], //表格表头数据
      tableData: [], //表格数据
      // 状态字段
      visible: false, //是否显示出模糊收索列表
      cursorMove: true, //聚焦是否可以移动
      rowIndex: 0, //行索引
      addShow: false, //新增弹出框是否显示
      searchShow: false, //选择弹出框是否显示
      searchData: {
        // 传入下一个弹出框的字段，包含标题，树状图url，表格url，过滤url
        title: "",
        url1: "",
        url2: "",
        url3: "",
        type: "",
        classify: ""
      }
    };
  },
  props: {
    labelName: [String],
    classify: [String],
    isdisable: {
      type: Boolean,
      default: false
    },
    visibles: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value1: {
      handler: function(newVal, oldVal) {
        if (newVal.KtypeId != this.oldVal1.KtypeId) {
          this.value1 = newVal;
          this.oldVal1 = newVal;
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
      immediate: true
    },
    // 默认选中表格第一行
    tableData: {
      handler: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          // this.$nextTick(()=>{
          this.$refs.xTable.setCurrentRow(this.tableData[0]);
          // })
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    },
    visible: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.rowIndex = 0;
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    // 扫码录入回车
    submitForm() {
      // console.log("我要执行回车了");
      if (this.value1 != "") {
        // if (!this.visible) {
        this.initListTable(this.value1);
        // } else {
        //   this.enterkey(this.$event);
        // }
      }
    },
    // 父组件调用子组件方法进行聚焦
    visiblefocus() {
      if (this.visibles) {
        this.$refs.Commodity.focus();
      }
    },
    // 点击添加
    addInfor() {
      // console.log('点击新增信息')
    },
    // 按上键
    upkey(e) {
      if (!this.visible) {
        this.$emit("preFocus");
      } else {
        if (this.rowIndex != 0) {
          this.rowIndex--;
        }
        this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 按下键
    downkey(e) {
      if (!this.visible) {
        this.$emit("nextFocus");
      } else {
        if (this.tableData && this.rowIndex + 1 < this.tableData.length) {
          this.rowIndex++;
        }
        this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 回车回调
    enterkey() {
      // 弹出模糊匹配框的时候回调数据
      if (this.visible) {
        if (this.tableData && this.tableData.length != 0) {
          this.chooseBack(this.$refs.xTable.getCurrentRow());
          this.visible = false;
        }
        return;
      }
      // 弹出选择框的时候回调数据
      if (this.searchShow) {
        // console.log("回调弹出选择框的数据");
        return;
      }
    },
    // 输入框输入文字
    inputText(text) {},
    // 初始化模糊匹配列表数据
    initListTable(Keyword) {
      let invid;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Keywords: Keyword,
        KtypeId: this.$attrs.warehouseVal1.KtypeId,
        KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        BuySale: this.$attrs.pargam.BuySale,
        BtypeId: this.$attrs.customerVal1.KtypeId,
        InvId: invid, // 盘点单 InvID没有投就传l
        MustBarCode: 1,
        Classify: "Goods"
      };
      this.request
        .post("/index/Goods/AllSearch", { jparams: JSON.stringify(params) })
        .then(res => {
          // 接收后端发送回来的数据
          if (res.status == 0) {
            if (res.data.length != 0) {
              this.$emit(
                "dateChange",
                ...res.data,
                this.CommodityQty,
                this.checked
              );

              this.value1 = "";
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 模糊查询时单击行选择数据
    clickRow(row) {
      this.chooseBack(row.row);
      return;
    },
    chooseBack(data) {
      console.log(data);
      return
      
      this.$emit("dateChange", data, this.CommodityQty, this.checked);
      this.value1 = "";
    },
    // 聚焦触发全输入框内容
    doFocus() {
      event.currentTarget.select();
      // this.oldVal1 = this.value1;
    },
    // 失去焦点，隐藏选择框
    doBlur() {
      this.visible = false;
      this.rowIndex = 0; //重置索引
      // this.$emit('dateChange',this.value1);此处不能绑定事件回调，否则会让报表调单时客户经手人等无法显示
    },
    // 清除数据
    clearData() {
      this.value1 = "";
      // this.$emit("dateChange", this.value1, this.CommodityQty, this.checked);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.ScanInput_lr {
  display: flex;
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }
  // .el-input--prefix .el-input__inner{
  //     padding-left: 65px;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/ScanInput/ScanInput.vue